/**
 * Guarda Mundo — pagamento mobile PDP (spec 0008)
 * Plataforma Apple, toggle “mais opções”, barra adaptativa (fits/docked/pinned/anchored).
 */
(function () {
  const PDP_SELECTOR = '[data-gm-pdp]';
  const ANCHOR_SELECTOR = '#gm-pdp-payment-anchor';
  const ALIGN_SELECTOR = '[data-gm-pdp-pay-align]';
  const SPACER_SELECTOR = '[data-gm-pdp-pay-spacer]';
  const STICKY_SELECTOR = '[data-gm-pdp-payment-mode="sticky"]';
  const LIVE_SELECTOR = '[data-gm-pdp-pay-live]';
  const INSTALLMENT_SELECTOR = '[data-gm-pdp-pay-installment]';
  const TOGGLE_SELECTOR = '[data-gm-pdp-pay-toggle]';
  const CLOSE_SELECTOR = '[data-gm-pdp-pay-close]';
  const METHODS_PANEL_SELECTOR = '[data-gm-pdp-pay-methods]';
  const METHOD_BTN_SELECTOR = '[data-gm-pdp-pay-method]';
  const PRIMARY_SELECTOR = '[data-gm-pdp-pay-primary]';
  const PRICE_SELECTOR = '.gm-pdp-intro__price';
  const MOBILE_MQ = '(max-width: 749px)';
  const FITS_BUFFER_PX = 8;
  const PRICE_CLEARANCE_PX = 4;
  const ANCHOR_VISIBLE_RATIO = 0.9;

  /** @type {number} */
  let collapsedBarHeight = 0;
  /** @type {boolean} */
  let rafScheduled = false;
  /** @type {ResizeObserver | null} */
  let barResizeObserver = null;

  /**
   * iPhone, iPad, Mac (Safari/desktop). Exclui Windows/Linux/Android.
   * @returns {boolean}
   */
  function detectApplePlatform() {
    const ua = navigator.userAgent || '';
    if (/Windows|Android|CrOS|Linux/i.test(ua)) return false;
    if (/iPhone|iPad|iPod/i.test(ua)) return true;
    if (/Macintosh|Mac OS X/i.test(ua)) return true;
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  }

  function applyApplePlatformUI() {
    const root = document.documentElement;
    const isApple = detectApplePlatform();

    if (isApple) {
      root.setAttribute('data-gm-pay-apple', 'true');
    } else {
      root.removeAttribute('data-gm-pay-apple');
    }

    document.querySelectorAll(PRIMARY_SELECTOR).forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      const ariaApple = btn.getAttribute('data-gm-pdp-pay-aria-apple');
      const ariaDefault = btn.getAttribute('data-gm-pdp-pay-aria-default');
      btn.setAttribute('aria-label', isApple && ariaApple ? ariaApple : ariaDefault || 'Comprar');
      btn.dataset.gmPdpPayMethod = isApple ? 'apple_pay' : 'checkout';
    });

    document.querySelectorAll('.gm-pdp-pay__methods-item--apple').forEach((item) => {
      if (!(item instanceof HTMLElement)) return;
      if (isApple) {
        item.removeAttribute('hidden');
      } else {
        item.setAttribute('hidden', '');
      }
    });
  }

  /** @type {number | null} */
  let safeAreaBottomCache = null;

  /**
   * @returns {number}
   */
  function getSafeAreaBottom() {
    if (safeAreaBottomCache !== null) return safeAreaBottomCache;
    const probe = document.createElement('div');
    probe.style.cssText =
      'position:fixed;bottom:0;height:env(safe-area-inset-bottom,0px);pointer-events:none;visibility:hidden';
    document.body.appendChild(probe);
    safeAreaBottomCache = probe.getBoundingClientRect().height;
    probe.remove();
    return safeAreaBottomCache;
  }

  /**
   * @returns {number}
   */
  function getHeaderOffset() {
    const header = document.querySelector('#header-component');
    if (header instanceof HTMLElement) {
      return Math.max(0, header.getBoundingClientRect().bottom);
    }
    return 0;
  }

  /**
   * Altura com painel fechado (teste “fits”).
   * @param {HTMLElement} sticky
   * @returns {number}
   */
  function measureCollapsedBarHeight(sticky) {
    const panel = sticky.querySelector(METHODS_PANEL_SELECTOR);
    if (panel instanceof HTMLElement && !panel.hidden) {
      return collapsedBarHeight > 0 ? collapsedBarHeight : sticky.offsetHeight;
    }
    collapsedBarHeight = sticky.offsetHeight;
    return collapsedBarHeight;
  }

  /**
   * @param {HTMLElement} sticky
   */
  function updateBarHeightVar(sticky) {
    const h = sticky.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--gm-pdp-pay-bar-height', `${Math.ceil(h)}px`);
  }

  /**
   * @param {HTMLElement | null} pdp
   */
  function syncInstallmentFromPdp(pdp) {
    if (!pdp) return;
    const installment = pdp.getAttribute('data-gm-installment');
    if (!installment) return;

    document.querySelectorAll(INSTALLMENT_SELECTOR).forEach((el) => {
      if (el instanceof HTMLElement) el.textContent = installment;
    });
  }

  /**
   * @param {string} message
   */
  function showMockNotice(message) {
    const live = document.querySelector(LIVE_SELECTOR);
    if (live instanceof HTMLElement) {
      live.textContent = message;
      live.classList.remove('visually-hidden');
      window.setTimeout(() => {
        live.textContent = '';
        live.classList.add('visually-hidden');
      }, 4000);
    }
  }

  /**
   * @param {HTMLElement} root
   */
  function bindPaymentButtons(root) {
    root.querySelectorAll(METHOD_BTN_SELECTOR).forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      if (btn.dataset.gmPdpPayBound === 'true') return;
      btn.dataset.gmPdpPayBound = 'true';
      btn.addEventListener('click', () => {
        const realAtc = document.querySelector(
          '.gm-pdp-hero__atc .gm-pdp-showcase__add-to-cart:not([disabled]), .gm-pdp-hero__atc button[name="add"]:not([disabled])'
        );
        if (realAtc instanceof HTMLButtonElement) {
          realAtc.click();
          return;
        }
        const live = document.querySelector(LIVE_SELECTOR);
        const msg =
          (live instanceof HTMLElement && live.getAttribute('data-gm-pdp-pay-notice-message')) ||
          'Compra disponível quando o produto estiver cadastrado na loja.';
        showMockNotice(msg);
      });
    });
  }

  /**
   * @param {HTMLElement | null} sticky
   * @param {HTMLElement | null} spacer
   */
  function hidePayBar(sticky, spacer) {
    if (!(sticky instanceof HTMLElement)) return;
    sticky.removeAttribute('data-gm-pdp-pay-sticky-visible');
    sticky.setAttribute('data-gm-pdp-pay-position', 'idle');
    sticky.style.removeProperty('top');
    sticky.style.removeProperty('bottom');
    document.documentElement.setAttribute('data-gm-pdp-pay-position', 'idle');
    document.documentElement.removeAttribute('data-gm-pdp-pay-panel-open');
    if (spacer instanceof HTMLElement) {
      spacer.hidden = true;
      spacer.style.height = '';
    }
    document.body.removeAttribute('data-gm-pdp-pay-bar-active');
  }

  /**
   * @param {'anchored'|'fits'|'docked'|'pinned'|'idle'} mode
   * @param {HTMLElement} sticky
   * @param {HTMLElement | null} spacer
   * @param {number} barHeight
   * @param {number} [topPx]
   */
  function applyPayPosition(mode, sticky, spacer, barHeight, topPx) {
    if (mode === 'idle') {
      hidePayBar(sticky, spacer);
      return;
    }

    sticky.setAttribute('data-gm-pdp-pay-position', mode);
    document.documentElement.setAttribute('data-gm-pdp-pay-position', mode);

    if (mode === 'anchored') {
      sticky.removeAttribute('data-gm-pdp-pay-sticky-visible');
      sticky.style.removeProperty('top');
      sticky.style.removeProperty('bottom');
      if (spacer instanceof HTMLElement) {
        spacer.hidden = true;
        spacer.style.height = '';
      }
      document.body.removeAttribute('data-gm-pdp-pay-bar-active');
      return;
    }

    sticky.setAttribute('data-gm-pdp-pay-sticky-visible', 'true');
    sticky.style.removeProperty('visibility');

    if (mode === 'docked' && typeof topPx === 'number') {
      sticky.style.top = `${topPx}px`;
      sticky.style.bottom = 'auto';
      if (spacer instanceof HTMLElement) {
        spacer.hidden = false;
        spacer.style.height = `${barHeight}px`;
      }
      document.body.removeAttribute('data-gm-pdp-pay-bar-active');
      return;
    }

    sticky.style.top = 'auto';
    sticky.style.bottom = '0';
    if (spacer instanceof HTMLElement) {
      spacer.hidden = true;
      spacer.style.height = '';
    }
    document.body.setAttribute('data-gm-pdp-pay-bar-active', 'true');
    updateBarHeightVar(sticky);
  }

  /**
   * @returns {number}
   */
  function getViewportHeight() {
    return window.visualViewport?.height ?? window.innerHeight;
  }

  /**
   * @returns {number}
   */
  function getPriceBottom() {
    const price = document.querySelector(PRICE_SELECTOR);
    if (price instanceof HTMLElement) {
      return price.getBoundingClientRect().bottom;
    }
    return 0;
  }

  /**
   * @returns {{ sticky: HTMLElement; panel: HTMLElement; toggle: HTMLButtonElement } | null}
   */
  function getStickyPanelOpen() {
    const sticky = document.querySelector(STICKY_SELECTOR);
    if (!(sticky instanceof HTMLElement)) return null;
    const panel = sticky.querySelector(METHODS_PANEL_SELECTOR);
    const toggle = sticky.querySelector(TOGGLE_SELECTOR);
    if (
      panel instanceof HTMLElement &&
      !panel.hidden &&
      toggle instanceof HTMLButtonElement
    ) {
      return { sticky, panel, toggle };
    }
    return null;
  }

  /**
   * @param {HTMLElement} payRoot
   */
  function closePaymentPanel(payRoot) {
    const root =
      payRoot instanceof HTMLElement
        ? payRoot
        : document.querySelector(STICKY_SELECTOR);
    if (!(root instanceof HTMLElement)) return;

    const panel = root.querySelector(METHODS_PANEL_SELECTOR);
    const toggle = root.querySelector(TOGGLE_SELECTOR);
    if (!(panel instanceof HTMLElement) || !(toggle instanceof HTMLButtonElement)) return;

    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.removeAttribute('data-gm-pdp-pay-panel-open');

    if (root.matches(STICKY_SELECTOR)) {
      collapsedBarHeight = root.offsetHeight;
    }

    schedulePayBarUpdate();
  }

  /**
   * @param {HTMLElement} sticky
   * @param {HTMLElement | null} spacerEl
   * @param {number} barHeight
   */
  function applyFloatMode(sticky, spacerEl, barHeight) {
    sticky.setAttribute('data-gm-pdp-pay-position', 'float');
    document.documentElement.setAttribute('data-gm-pdp-pay-position', 'float');
    document.documentElement.setAttribute('data-gm-pdp-pay-panel-open', 'true');
    sticky.setAttribute('data-gm-pdp-pay-sticky-visible', 'true');
    sticky.style.removeProperty('visibility');
    sticky.style.removeProperty('top');
    sticky.style.bottom = '0';
    sticky.style.left = '0';
    sticky.style.right = '0';
    if (spacerEl instanceof HTMLElement) {
      spacerEl.hidden = true;
      spacerEl.style.height = '';
    }
    document.body.setAttribute('data-gm-pdp-pay-bar-active', 'true');
    updateBarHeightVar(sticky);
  }

  function bindPanelCloseButtons() {
    document.querySelectorAll(CLOSE_SELECTOR).forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      if (btn.dataset.gmPdpPayCloseBound === 'true') return;
      btn.dataset.gmPdpPayCloseBound = 'true';
      btn.addEventListener('click', () => {
        const payRoot = btn.closest('[data-gm-pdp-payment]');
        if (payRoot instanceof HTMLElement) {
          closePaymentPanel(payRoot);
        }
      });
    });
  }

  function updatePayBarPosition() {
    const mobile = window.matchMedia(MOBILE_MQ);
    const sticky = document.querySelector(STICKY_SELECTOR);
    const anchor = document.querySelector(ANCHOR_SELECTOR);
    const divider = document.querySelector(ALIGN_SELECTOR);
    const spacer = document.querySelector(SPACER_SELECTOR);
    const spacerEl = spacer instanceof HTMLElement ? spacer : null;

    if (!(sticky instanceof HTMLElement) || !mobile.matches) {
      hidePayBar(sticky instanceof HTMLElement ? sticky : null, spacerEl);
      document.documentElement.removeAttribute('data-gm-pdp-pay-position');
      return;
    }

    const vh = getViewportHeight();
    const panelOpen = getStickyPanelOpen();

    /*
     * Painel de meios de pagamento aberto: só modo float no rodapé.
     * Ignora dock / idle / anchor / overlap — fecha apenas pelo chevron.
     */
    if (panelOpen) {
      sticky.setAttribute('data-gm-pdp-pay-sticky-visible', 'true');
      sticky.style.removeProperty('visibility');
      applyFloatMode(sticky, spacerEl, panelOpen.sticky.offsetHeight);
      return;
    }

    document.documentElement.removeAttribute('data-gm-pdp-pay-panel-open');

    /* Medir altura mesmo quando a barra está oculta (display:none → offsetHeight 0). */
    const wasVisible = sticky.hasAttribute('data-gm-pdp-pay-sticky-visible');
    if (!wasVisible) {
      sticky.setAttribute('data-gm-pdp-pay-sticky-visible', 'true');
      sticky.style.visibility = 'hidden';
    }
    const barHeight = sticky.offsetHeight;
    const collapsedHeight = measureCollapsedBarHeight(sticky);
    if (!wasVisible) {
      sticky.removeAttribute('data-gm-pdp-pay-sticky-visible');
    }
    sticky.style.removeProperty('visibility');

    if (anchor instanceof HTMLElement) {
      const anchorRect = anchor.getBoundingClientRect();
      const anchorInView = anchorRect.top < vh * ANCHOR_VISIBLE_RATIO && anchorRect.bottom > 0;
      if (anchorInView) {
        applyPayPosition('anchored', sticky, spacerEl, barHeight);
        return;
      }
    }

    if (!(divider instanceof HTMLElement)) {
      applyPayPosition('fits', sticky, spacerEl, barHeight);
      return;
    }

    const dividerRect = divider.getBoundingClientRect();
    const dividerTop = dividerRect.top;
    const dividerBottom = dividerRect.bottom;
    const priceBottom = getPriceBottom();
    const headerOffset = getHeaderOffset();
    const safeBottom = getSafeAreaBottom();

    /* Divisor ainda não entrou na tela: não fixar no bottom (cobriria hero/preço). */
    if (dividerTop > vh) {
      hidePayBar(sticky, spacerEl);
      return;
    }

    /*
     * Intro já rolou para cima: barra no rodapé (comportamento clássico).
     */
    if (dividerBottom < 0) {
      applyPayPosition('pinned', sticky, spacerEl, barHeight);
      return;
    }

    const spaceBelowDivider = vh - dividerTop;
    const barFitsBelowDividerInViewport =
      dividerBottom + collapsedHeight + FITS_BUFFER_PX <= vh - safeBottom;

    /*
     * Cabe abaixo do divisor com folga: fixa no bottom desde que não invada o preço.
     */
    if (
      spaceBelowDivider >= collapsedHeight + FITS_BUFFER_PX &&
      barFitsBelowDividerInViewport &&
      vh - barHeight - safeBottom >= priceBottom + PRICE_CLEARANCE_PX
    ) {
      applyPayPosition('fits', sticky, spacerEl, barHeight);
      return;
    }

    /*
     * Viewport compacto: borda superior da barra no divisor (nunca clamp ao bottom sobre o preço).
     */
    const dockedTop = Math.max(headerOffset, dividerTop, priceBottom + PRICE_CLEARANCE_PX);

    applyPayPosition('docked', sticky, spacerEl, barHeight, dockedTop);
  }

  function schedulePayBarUpdate() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(() => {
      rafScheduled = false;
      updatePayBarPosition();
    });
  }

  /**
   * @param {HTMLButtonElement} toggle
   * @param {HTMLElement | null} stickyBar
   */
  function bindMoreOptionsToggle(toggle, stickyBar) {
    if (toggle.dataset.gmPdpPayToggleBound === 'true') return;
    toggle.dataset.gmPdpPayToggleBound = 'true';

    const panelId = toggle.getAttribute('aria-controls');
    const panel =
      (panelId && document.getElementById(panelId)) ||
      toggle.closest('[data-gm-pdp-payment]')?.querySelector(METHODS_PANEL_SELECTOR);

    if (!(panel instanceof HTMLElement)) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !expanded;
      toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      panel.hidden = !nextExpanded;

      if (nextExpanded && stickyBar instanceof HTMLElement) {
        document.documentElement.setAttribute('data-gm-pdp-pay-panel-open', 'true');
      } else {
        document.documentElement.removeAttribute('data-gm-pdp-pay-panel-open');
        if (stickyBar instanceof HTMLElement) {
          collapsedBarHeight = stickyBar.offsetHeight;
        }
      }

      schedulePayBarUpdate();
    });
  }

  /**
   * @param {HTMLElement} sticky
   */
  function observeStickyBar(sticky) {
    if (barResizeObserver || typeof ResizeObserver === 'undefined') return;
    barResizeObserver = new ResizeObserver(() => {
      schedulePayBarUpdate();
    });
    barResizeObserver.observe(sticky);
  }

  /**
   * @param {HTMLElement} sticky
   * @param {HTMLElement | null} anchor
   */
  function initStickyBar(sticky, anchor) {
    const mobile = window.matchMedia(MOBILE_MQ);

    observeStickyBar(sticky);

    window.addEventListener('scroll', schedulePayBarUpdate, { passive: true });
    window.addEventListener('resize', schedulePayBarUpdate, { passive: true });
    mobile.addEventListener('change', schedulePayBarUpdate);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedulePayBarUpdate);
      window.visualViewport.addEventListener('scroll', schedulePayBarUpdate);
    }

    document.querySelectorAll(TOGGLE_SELECTOR).forEach((toggle) => {
      if (toggle instanceof HTMLButtonElement && toggle.closest('[data-gm-pdp-payment-mode="sticky"]')) {
        bindMoreOptionsToggle(toggle, sticky);
      }
    });

    collapsedBarHeight = sticky.offsetHeight;
    schedulePayBarUpdate();
  }

  function init() {
    applyApplePlatformUI();

    if (!window.matchMedia(MOBILE_MQ).matches) return;

    const pdp = document.querySelector(PDP_SELECTOR);
    const anchor = document.querySelector(ANCHOR_SELECTOR);
    const sticky = document.querySelector(STICKY_SELECTOR);

    syncInstallmentFromPdp(pdp instanceof HTMLElement ? pdp : null);

    document.querySelectorAll('[data-gm-pdp-payment]').forEach((block) => {
      if (block instanceof HTMLElement) bindPaymentButtons(block);
    });

    bindPanelCloseButtons();

    document.querySelectorAll(TOGGLE_SELECTOR).forEach((toggle) => {
      if (!(toggle instanceof HTMLButtonElement)) return;
      const inSticky = toggle.closest('[data-gm-pdp-payment-mode="sticky"]');
      if (!inSticky) {
        bindMoreOptionsToggle(toggle, null);
      }
    });

    if (sticky instanceof HTMLElement) {
      initStickyBar(sticky, anchor instanceof HTMLElement ? anchor : null);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
